import { useState, useEffect } from "react";

export default function BType({ defaultValue, isNew, errors }) {
  const options = [
    { id: "b1", label: "ՊԱՆԵԼԱՅԻՆ", value: "Panel" },
    { id: "b2", label: "ՔԱՐԵ", value: "Stone" },
    { id: "b3", label: "ՄՈՆՈԼԻՏ", value: "Monolith" },
    { id: "b4", label: "ԱՅԼ", value: "Other" },
  ];

 const [value, setValue] = useState(defaultValue || "");
 const [newStatus, setNewStatus] = useState(isNew === "on");

 useEffect(() => {
   if (defaultValue) {
     setValue(defaultValue);
   }
 }, [defaultValue]);

useEffect(() => {
    setNewStatus(isNew === "on");
  }, [isNew]);

  const [isSmall] = useState(window.innerWidth <= 1500);

  return (
    <div
      className="bType"
      style={{
        border: errors?.building_type ? "2px solid red" : "none",
        borderRadius: "10px",
      }}
    >
      <h5>{isSmall ? "ՇԻՆ. ՏԻՊ" : "ՇԻՆՈՒԹՅԱՆ ՏԻՊ"}</h5>

      <div className="with">
        {options.map((type) => (
          <div key={type.id}>
            <input
              type="radio"
              name="building_type"
              id={type.id}
              value={type.value}
              checked={value === type.value}
              onChange={(e) => setValue(e.target.value)}
            />
            <label htmlFor={type.id}>{type.label}</label>
          </div>
        ))}
      </div>

      <div className="newbuilding">
        {/* в форму всегда уходит "on" или "" */}
        <input type="hidden" name="new_status" value={newStatus ? "on" : ""} />

        <input
          id="new_status"
          type="checkbox"
          checked={newStatus}
          onChange={(e) => setNewStatus(e.target.checked)}
        />
        <label htmlFor="new_status">{isSmall ? "ՆՈՐԱԿԱՌ" : "ՆՈՐԱԿԱՌՈՒՅՑ"}</label>
      </div>
    </div>
  );
}
